const setMinMaxHouse = (payload) => {
  return {
    type: "minmaxhouseChange",
    payload,
  };
};
export default setMinMaxHouse;
